import { Typography } from "@mui/material"
import imageBoxIconImage from "src/assets/icons/empty-box.webp"
import { CenteredBox } from "../centered-box"

const EmptyBox = ({ text }: { text?: string }) => {
  return (
    <CenteredBox height={"100%"}>
      <img
        src={imageBoxIconImage}
        style={{
          filter: "invert(70%) sepia(6%) saturate(104%) hue-rotate(180deg) brightness(95%) contrast(90%)"
        }}
        width={"75px"}
        alt="No Data"
      />
      {text && (
        <Typography variant="body2" fontWeight={500} color="grey">
          {text}
        </Typography>
      )}
    </CenteredBox>
  )
}

export default EmptyBox
